module.exports = __webpack_public_path__ + "static/media/three.0554746d.jpg";